<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

import dialog from '@/styles/jobEditDialog.module.scss';

export interface Props {
  errorMessage?: string;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  errorMessage: 'Job not found',
});

const emit = defineEmits<{
  okayBtnClick: [event: Event];
}>();

function handleOkayClick(event: Event): void {
  emit('okayBtnClick', event);
}
</script>

<template>
  <PageDialogWrapper
    :class="[$style.jobEditNotFoundDialog, dialog.dialogRoot]"
    data-testid="jobEditNotFoundDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader :show-close-btn="false">
        Job Not Found
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="dialog.text">
        {{ props.errorMessage }}
      </div>
    </section>

    <template #footer>
      <menu :class="dialog.dialogFooterMenuList">
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn append-icon="mdi-check" @click="handleOkayClick"> Okay </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
.jobEditNotFoundDialog {
}
</style>
